import { render, staticRenderFns } from "./domain.vue?vue&type=template&id=8afbc976&scoped=true&"
import script from "./domain.vue?vue&type=script&lang=js&"
export * from "./domain.vue?vue&type=script&lang=js&"
import style0 from "./domain.vue?vue&type=style&index=0&id=8afbc976&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afbc976",
  null
  
)

export default component.exports